var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SlideToggle',{attrs:{"value":_vm.value,"options":_vm.options,"containerClass":"tw-min-w-[320px]"},on:{"input":(e) => _vm.$emit('input', e)}})
}
var staticRenderFns = []

export { render, staticRenderFns }